import { useEffect, useState } from 'react';

import { updateSettings } from '../../../api/services/Settings';
import { useAuthQuery } from '../../../auth/hooks/useAuthQuery';

export function useSettingsForm() {
  const [accountInfo, setAccountInfo] = useState<AccountInfo>();
  const [editMode, setEditMode] = useState(false);
  const { userSettings, setUserSettings } = useAuthQuery();

  useEffect(() => {
    if (userSettings) {
      setAccountInfo(userSettings);
    }
  }, [userSettings]);

  function editModeToggle() {
    setEditMode((prev) => !prev);
  }

  async function saveSettings(payload: AccountInfo) {
    setAccountInfo(payload);

    let response;

    if (payload.enableAbsentRiderDailyEmail === 'Yes') {
      const notifications: NotificationInfo = {
        absentRiders: {
          enabled: payload.sendEmailDailyReport === 'Yes',
          options: {
            emails: payload.dailyReportEmailList?.replace(/\s+/g, '').split(',') || [],
          },
        },
      };

      response = await updateSettings({ ...payload, notifications });
    } else {
      response = await updateSettings(payload);
    }

    if (response.type === 'success') {
      setUserSettings({ ...userSettings, ...payload });
    }
  }

  return {
    accountInfo,
    editMode,
    editModeToggle,
    saveSettings,
  };
}
